// Submenú desplegado al arrancar: uno solo. Las sesiones viejas dejaron en
// localStorage una lista acumulada ("geografia,imports,..."), que abría varios
// submenús a la vez.
function loadCurrentSubmenu() {
  const raw = localStorage.getItem('currentSubmenu')
  if (!raw) return []
  const first = raw.split(',').filter(Boolean)[0]
  return first ? [first] : []
}

const state = {
  availableDate: null,
  startDate: null,
  lastClosedDate: null,
  menuOpen: true,
  currentSubmenu: loadCurrentSubmenu(),
  loading: false,
  showViewAdmin: false
};

const getters = {
  getAvailableDate: state => {
    return state.availableDate
  },
  getStartDate: state => {
    return state.startDate;
  },
  getLastClosedDate: state => {
    return state.lastClosedDate;
  },
  getCurrentSubmenu: state => state.currentSubmenu,
  isMenuOpen : state=> state.menuOpen,
  isLoading: state => state.loading,
  getShowViewAdmin: state => {
    return state.showViewAdmin;
  }
};

const actions = {
  loading: (store, val) => {
    store.commit('setLoading', val)
  }
};

const mutations = {
  setShowViewAdmin(state, value) {
    state.showViewAdmin = value;
  },
  availableDate(state, value) {
    state.availableDate = value;
  },
  startDate(state, value) {
    state.startDate = value;
  },
  lastClosedDate(state, value) {
    state.lastClosedDate = value;
  },
  // Un solo grupo desplegado a la vez: antes se acumulaban y, como el estado
  // se guarda en localStorage, quedaban varios submenús abiertos entre sesiones.
  setCurrentSubmenu(state, value) {
      state.currentSubmenu = state.currentSubmenu.includes(value) ? [] : [value]
      localStorage.setItem('currentSubmenu', state.currentSubmenu)
  },
  toggleMenu(state) {
    if (!window.matchMedia("(max-width: 768px)").matches) {
      state.menuOpen = !state.menuOpen
    }
  },
  setMenu(state, value) {
    state.menuOpen = value
  },
  setLoading(state, value) {
    state.loading = value
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
